import Input from '../../ui/Input';
import Heading from '../../ui/Heading';
import Button from '../../ui/Button';

import { useController, useForm } from 'react-hook-form';
import AddProfileImage from '../../assets/icons/AddProfileImage';
import Info from '../../assets/icons/Info';
import BackButton from '../../assets/icons/BackButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { createOrganizationAtDb, editOrganisation } from '../../apis/oragnisations/organisation';
import Loader from '../../ui/Loader';
import { useLoadingState } from '../../hooks/useLoader';
import EditLogo from '../../assets/icons/EditLogo';
import { deepEqual } from '../../helpers/deepEqual';
import CharacterLimit from '../../ui/CharacterLimit';
import { uploader } from '../../helpers/uploader';
import Dropdown from '../../ui/Dropdown';
import ButtonNew from '../../ui/ButtonNew';
import { compressImage } from '../../helpers/compressor';
// const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#?&%=_\-]*)*$/;
const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9#?&%=_\-]*)*$/;
const countries = ["India", "Outside India"]
const countryCodes = {
    "India": "IN",
    "Outside India": "OTHERS"
}


const uploadFile = async (file) => {
    try {
        // startUploading();

        const res = await uploader(file);
        return res;
        // if (res.files.length) {
        //     setUploadPicture({
        //         image: file,
        //         imageURL: res.files[0],
        //     });
        //     fieldName.onChange(res.files[0]);
        // toast.success('Image is successfully uploaded.');
        // } else {
        //     console.log("aas")
        // toast.error('Sorry unable to upload logo');
        // }
        // stopUploading();
    } catch (error) {
        console.error('Error uploading file:', error);
        // setUploadStatus('File upload failed.');
    }
};
function OrganizationInput({ edit = false, prefilledData, setParticularOrg }) {
    const {
        register,
        handleSubmit,
        getValues,
        clearErrors,
        setError,
        control,
        formState: { errors },
    } = useForm(
        edit
            ? {
                mode: 'onChange',
                defaultValues: prefilledData,
            }
            : {
                mode: 'onChange',
            }
    );
    const { id } = useParams();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { loading: compressing, startLoading: startCompressing, stopLoading: stopCompressing } = useLoadingState();

    const [imageObject, setImage] = useState(() => {
        return edit ? { image: null, imageURL: prefilledData?.orgLogo } : { image: null, imageURL: '' };
    });
    const handleImageChange = async (e) => {
        const file = e.target.files?.[0];
        if (file) {
            startCompressing();
            try {
                const processedFile = await compressImage(file, 9.5);
                clearErrors('orgLogo');
                setImage({
                    image: processedFile,
                    imageURL: URL.createObjectURL(processedFile),
                });
            } catch (error) {
                console.error("Image processing failed", error);
                const errorMessage = error?.message || (typeof error === 'string' ? error : "Image processing failed");
                setError('orgLogo', {
                    type: 'manual',
                    message: errorMessage
                });
                e.target.value = null; // Reset input
            }
            stopCompressing();
        }
    };
    const navigate = useNavigate();
    const { field: orgTaglineField } = useController({
        name: 'orgTagline',
        control,
        rules: {
            required: 'Please enter a tagline.',
            maxLength: {
                value: 50,
                message: 'The maximum length is 50 characters.',
            },
        },
    });
    const { field: countryField } = useController({
        name: 'country',
        control,
        rules: { required: 'Please choose a country based out of' },
    });
    const { field: orgNameField } = useController({
        name: 'orgName',
        control,
        rules: {
            required: edit ? false : 'Please enter a title',
            maxLength: {
                value: 100,
                message: 'The maximum length is 100 characters',
            },
        },
    });
    const { field: orgDescriptionField } = useController({
        name: 'orgDescription',
        control,
        rules: {
            required: 'Please enter a brief description',
            maxLength: {
                value: 1000,
                message: 'The maximum length is 1,000 characters.',
            },
        },
    });
    const { image, imageURL } = imageObject;
    const onSubmit = async (data) => {
        data.orgLogo = imageObject.image;
        data.country = countryCodes[data.country];
        const { link1, link2, link3, ...dataToSend } = data;
        const handles = [link1, link2, link3];
        if (!edit) {
            dataToSend['handles[0]'] = handles[0];
            if (handles[1]) dataToSend['handles[1]'] = handles[1];
            if (handles[2]) dataToSend['handles[2]'] = handles[2];
        }

        if (edit) {
            // dataToSend.orgLogo = imageObject.imageURL;
            dataToSend.handles = handles.filter((link) => link);
            const { link1, link2, link3, ...prevObj } = prefilledData;
            const prevHandles = [link1, link2, link3];
            prevObj.handles = prevHandles.filter((link) => link);

            // const isDetailsSame = deepEqual(dataToSend, prevObj);

            startLoading();
            const upres = await uploadFile(dataToSend?.orgLogo);

            const payloadObject = {
                logo: upres?.files[0],
                description: dataToSend.orgDescription,
                tagline: dataToSend.orgTagline,
                handles: dataToSend.handles,
            };

            const response = await editOrganisation(payloadObject, id);

            setParticularOrg((initial) => ({ ...initial, ...payloadObject }));

            if (response?.status === 200) {
                stopLoading();
                navigate(-1);
            }
            return;
        }

        const orgToSend = new FormData();

        for (let [key, value] of Object.entries(dataToSend)) {
            orgToSend.append(key, value);
        }
        startLoading();
        const response = await createOrganizationAtDb(orgToSend);

        stopLoading();
        if (response.status === 'SUBMITTED') navigate(-1);
        // dispatch({ type: 'updateAfterProfileCreation', payload: response });
        // if (Object.keys(response).length) navigate('/', { replace: true });
    };
    console.log(errors);
    return (
        <div className="w-8/12 mx-auto flex gap-3 items-start py-6   ">
            {!edit && <BackButton className={'relative top-2'} onClick={() => navigate(-1)} />}
            <form onSubmit={handleSubmit(onSubmit)} className=" w-[100%] ">
                {!edit && (
                    <div className="mb-7 ">
                        <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                            Organization Title <sup className="text-lg relative top-[1px]">*</sup>
                        </Heading>
                        <Input
                            {...orgNameField}
                            error={errors?.orgName?.message}
                            placeholder={'Type your organization’s name'}
                            className={'w-[100%]'}
                        />
                        <CharacterLimit min={orgNameField.value ? orgNameField.value.length : 0} max={100} />
                    </div>
                )}
                <div className="mb-7">
                    <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                        Tagline <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>
                    <Input
                        {...orgTaglineField}
                        error={errors?.orgTagline?.message}
                        placeholder={'Describe your organization’s purpose in 1 line'}
                        className={'w-[100%]'}
                    />
                    <CharacterLimit min={orgTaglineField?.value?.length} max={50} />
                </div>

                <div className='mb-7'>
                    <Heading type="medium" className="capitalize text-textPrimary  mb-2">
                        Which country is the organization based out of <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>

                    <div className="relative">
                        <Dropdown
                            w="w-full"
                            data={countries}
                            selected={countryField.value}
                            onSelected={countryField.onChange}
                            noSelectedText={
                                <span className="flex items-center gap-[7px]">
                                    <span>Choose a country organization based out of</span>
                                </span>
                            }

                        />
                    </div>
                    <div className="">
                        <p className="text-foundryRed  ">
                            {errors?.country?.message && errors?.country?.message}
                        </p>
                    </div>
                </div>
                <div className="mb-7">
                    <Heading type="medium" className="capitalize text-textPrimary mb-2">
                        Brief Description <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>

                    <Input
                        {...orgDescriptionField}
                        error={errors?.orgDescription?.message}
                        type="textArea"
                        name="orgDescription"
                        placeholder={'What does this organization do ?'}
                        className={'w-[100%]'}
                    />
                    <CharacterLimit min={orgDescriptionField?.value?.length} max={1000} />
                </div>
                <div className="mb-7">
                    <Heading type="medium" className="capitalize text-textPrimary mb-2">
                        Organization Social Links
                    </Heading>
                    <p className="font-medium mb-2 text-textSecondary ">
                        Link to your organization’s Website, Twitter, LinkedIn or Instagram. <br /> Ensure to add at
                        least one link for verification.
                    </p>
                    <div className="flex flex-col gap-2">
                        <Input
                            {...register('link1', {
                                required: 'Please enter a social link',
                                // pattern: {
                                //     value: urlRegex,
                                //     message: 'Please enter valid url.',
                                // },
                            })}
                            type="text"
                            error={errors?.link1?.message}
                            placeholder={'Link 1 *'}
                            className={'w-[100%]'}
                        />

                        <Input
                            {...register('link2', {
                                // pattern: {
                                //     value: urlRegex,
                                //     message: 'Please enter valid url.',
                                // },
                                validate: (value) => {
                                    // Check if link1 is empty when link2 has a value
                                    if (value && !getValues('link1')) {
                                        return 'You cannot enter Link 2 if Link 1 is not entered.';
                                    }
                                    return true;
                                },
                            })}
                            type="text"
                            placeholder={'Link 2(optional)'}
                            error={errors?.link2?.message}
                            className={'w-[100%]'}
                        />
                        <Input
                            {...register('link3', {
                                // pattern: {
                                //     value: urlRegex,
                                //     message: 'Please enter valid url.',
                                // },
                                validate: (value) => {
                                    // Check if link1 is empty when link2 has a value
                                    if (value && !(getValues('link1') && getValues('link2'))) {
                                        return 'You cannot enter Link 3 if Link 1 and Link 2 is not entered.';
                                    }
                                    return true;
                                },
                            })}
                            type="text"
                            placeholder={'Link 3(optional)'}
                            error={errors?.link3?.message}
                            className={'w-[100%]'}
                        />
                    </div>
                </div>
                <div className="mb-7">
                    <Heading type="medium" className="capitalize text-textPrimary mb-2">
                        Upload Organization Logo <sup className="text-lg relative top-[1px]">*</sup>
                    </Heading>
                    <div className="p-6 bg-grayBgNormal  flex flex-col text-uploadText items-center shadow-sm rounded-md ">
                        <div className="border flex flex-col gap-2  border-borderUnderline border-dashed w-full p-6 rounded-md">
                            {compressing ? (
                                <div className="flex flex-col gap-2 items-center justify-center p-4">
                                    <Loader />
                                    <p className="text-sm font-medium animate-pulse">Compressing...</p>
                                </div>
                            ) : !imageURL ? (
                                <>
                                    {' '}
                                    <label className="flex flex-col gap-2 items-center" htmlFor="avatar">
                                        <AddProfileImage />
                                        <p className='text-textSecondary' >Click to choose files</p>
                                    </label>
                                    <Input
                                        id="avatar"
                                        type="file"
                                        {...register('orgLogo', {
                                            required: 'Please upload an organization logo.',
                                        })}
                                        onChange={handleImageChange}
                                    />
                                </>
                            ) : (
                                <div className="relative">
                                    <img
                                        className="w-20 h-20 rounded-md object-center object-cover"
                                        src={imageURL}
                                        alt="profile"
                                    />
                                    <label htmlFor="avatar" className="cursor-pointer absolute top-0 right-0 ">
                                        <EditLogo />
                                        <Input
                                            id="avatar"
                                            type="file"
                                            onChange={handleImageChange}
                                        />
                                    </label>
                                </div>
                            )}

                            {!imageURL && (
                                <div className="flex gap-2 justify-center items-center">
                                    <Info />
                                    <p className="font-semibold text-textSecondary">Ideal File Size: 9.5MB; Ideal dimensions: 75x75 px</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <p className="text-foundryRed mt-1">{errors?.orgLogo?.message}</p>
                </div>

                <div>
                    {edit ? (
                        <div type={'submit'} className="flex items-center justify-end">

                            <ButtonNew
                                type="submit"
                                disabled={loading}
                                fixedMinWidth={true}
                                variant="blue"
                                size="sm" >
                                {loading ? <Loader /> : 'Save'}
                            </ButtonNew>
                        </div>
                    ) : (
                        <ButtonNew
                            type="submit"
                            disabled={loading}
                            fixedMinWidth={true}
                            minWidthClass={"min-w-[50%]"}
                            variant="orange"
                            size="sm" >
                            {!loading ? ' Submit Application' : <Loader />}
                        </ButtonNew>

                    )}
                </div>
            </form>
        </div>
    );
}

export default OrganizationInput;
